<template>
  <div >
    <multiselect class="multiselector"
      v-model="selectedOption"
      :options="listOptions"
      :label="listLabel"
      :track-by="listValue"
      placeholder=""
      :clear-on-select="true"
      :show-labels="false"
      :multiple="false"
    />
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'searchable-select',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedOption: this.value ? this.value : null,
        listOptions: JSON.parse(this.options),
        listLabel: this.labelName ? this.labelName : 'name',
        listValue: this.valueName ? this.valueName : 'id',
      }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
      setNewValue(newValue){
        var el = document.getElementById(this.hiddenElement)
        if (el){
          el.value = newValue[this.$data.listValue]
        }
      },
    },
    props: {
      options: {
        type: String,
        required: true,
      },
      optionsSource: {
        type: String,
        required: false,
      },
      value: {
        type: String,
        required: false,
      },
      labelName: {
        type: String,
        required: false,
      },
      valueName: {
        type: String,
        required: false,
      },
      hiddenElement: {
        type: String,
        required: true,
      },
    },
    watch: {
      selectedOption (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.setNewValue(newVal)
        }
      },
    },
  }
</script>

<style lang="scss">
  .multiselector {
    min-width: 14rem;
    max-width: 100%;
  }
</style>
